import React from "react";
import classNames from "classnames";
import { websiteBuilderGenerateImageDesignStyles, IWebsiteBuilderImage } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderImage";

interface IWebsiteBuilderImageViewProps {
  node: IWebsiteBuilderImage;
}

export function WebsiteBuilderImageView(props: IWebsiteBuilderImageViewProps) {
  const { node } = props;

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateImageDesignStyles(settings);

  return (
    <div className={designStyles.containerClassName} style={designStyles.containerStyleProperties}>
      {settings.src && (
        <img
          className={classNames(designStyles.className, "editor-image")}
          style={designStyles.styleProperties}
          src={settings.src}
          alt={settings.alt}
        />
      )}
    </div>
  );
}
